export const vehicleHistoryRoutes = ['vehiclesHistory', 'plateHistory'];
